module.exports = "https://coursera_assets.s3.amazonaws.com/images/f01ec381c5b6a6538109614574f70dc8.png";